export const faqGetters = {
  faqFormStatus: (state) => state.faqFormStatus,
  faqIsEdit: state => state.faqIsEdit,
  faqSelectedForEdit: state => state.faqSelectedForEdit,
  faqBackFromEditPage :state => state.faqBackFromEditPage,
  faqTableItems :state => state.faqTableItems,
  faqPageCount :state => state.faqPageCount,
};